<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M609 955c114 0 210-73 210-192 0-106-76-190-184-190-48 0-86 12-112 34h-2l21-117h245v-89H467l-53 296h104c20-23 49-34 89-34 61 0 101 39 101 100 0 59-42 102-101 102-54 0-99-23-110-79H391c11 116 110 169 218 169zm-10-831c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528z" />
  </svg>
</template>
